module.exports = __webpack_public_path__ + "img/search_plance.790c0dde.png";